import styled from 'styled-components';
import grey from 'sushiweb/tokens/color/grey';
import white from 'sushiweb/tokens/color/white';
import { P } from 'sushiweb/Typography/Text';
import Input from 'sushiweb/InputTypes/Input';
import Layout from 'sushiweb/Layout/Layout';

export const uploadBtnStyle = {
  width: '546px',
  height: '54px',
  borderRadius: '5px',
  border: '1px dashed var(--redred-500, #EF4F5F)',
  background: '#FFF5F6',
  cursor: 'pointer',
};

export const ChipsConatiner = styled.div`
  padding: 1rem 1.2rem 1rem 1.2rem;
`;

export const disabledUploadBtnStyle = {
  width: '546px',
  height: '54px',
  borderRadius: '5px',
  border: '0.5px dashed var(--coolgreycoolgrey-500, #9197A6)',
  background: 'var(--coolgreycoolgrey-100, #F2F4F7)',
  cursor: 'pointer',
};

export const uploadFileText = {
  marginTop: '-105px',
  fontWeight: 200,
};

export const downloadBtnStyle = {
  background: grey.z100,
  color: '#293142',
  border: '0px',
};
export const clearFileBtnStyle = {
  background: grey.z100,
  color: '#293142',
  border: '0px',
  padding: '0px',
  marginTop: '-6px',
};

export const chipsStyle = {
  chipBg: grey.z200,
  chipFont: grey.z800,
  chipCross: grey.z800,
};

export const ModalFieldsWrapper = styled.div`
  margin-top: 10px;
  border-top: 1.5px solid #f2f4f7;
  width: 634px;
`;
export const ModalSuccessWrapper = styled.div`
  width: 100%;
  margin-top: 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  h5 {
    font-weight: 500;
    margin-top: 2.8rem;
  }
  p {
    margin: 1rem 0 2.4rem;
    font-size: 1.6rem;
  }
`;

export const CreateGroupModalFooter = styled.div`
  display: flex;
  width: 100%;
  height: 73px;
  margin-top: 20px;
  padding: 15px 24px 14px 24px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  border-radius: 0px 0px 5px 5px;
  background: var(--coolgreycoolgrey-200, #E6E9EF);
  }
`;

export const UnsuccessfulUploadText = styled.div`
  h5 {
    font-weight: 500;
    font-size: 1.5rem;
  }
  p {
    margin: 0.8rem 0 2.4rem;
    font-size: 1.3rem;
`;
export const UnsuccessfulDownloadText = styled.a`
  display: inline-flex;
  padding: 12px 20px;
  align-items: center;
  border-radius: 12px;
  border: 0px solid var(--redred-100, #ffedef);
  background: var(--basewhite-000, #fff);
`;
export const UnsuccessfulDownloadBtn = styled.div`
  display: inline-flex;
  padding: 2px 6px;
  align-items: center;
  border-radius: 12px;
  border: 0px solid var(--redred-100, #ffedef);
  background: var(--basewhite-000, #fff);
  color: var(--coolgreycoolgrey-800, #414a5d);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
export const UploadIconWhite = styled.div`
  padding-left: 5px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;
export const StyledP = styled(P)`
  font-size: 1.8rem;
  font-weight: 400;
  color: '#1C1C1C';
  margin-bottom: 1.5rem;
`;

export const CreateButtonWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: end;
`;

export const FormWrapper = styled.div`
  width: 100%;
  margin-top: 1.4rem;
  background: ${white};
  border: 0.1rem solid ${grey.z200};
  border-radius: 0.8rem;
  padding: 3.4rem 2.6rem;
  h5 {
    margin-bottom: 2.4rem;
  }
`;

export const UploadFileWrapper = styled.div`
  width: 100%;
  margin-top: 1.4rem;
  background: ${grey.z100};
  border: 0.1rem solid ${grey.z200};
  border-radius: 0.8rem;
  padding: 1.4rem 1.6rem;
  h5 {
    margin-bottom: 2.4rem;
  }
`;
export const CreateTeamHelperText = styled.span`
  color: var(--coolgreycoolgrey-400, #afb4c0);
  font-size: 12px;
  margin-top: -10px;
`;
export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  p {
    font-size: 1.6rem;
    margin-bottom: 1rem;
    color: ${grey.z900};
  }
`;
InputWrapper.HelperText = styled.div`
  font-size: 1.3rem;
  margin-top: 0.8rem;
  color: ${grey.z600};
`;
export const StyledLayout = styled(Layout)`
  margin-bottom: 1.3rem;
  margin-top: 1.3rem;
`;

export const StyledInput = styled(Input)`
  margin-top: 1.2rem;
  width: 100%;
`;
export const UploadSectionContainer = styled.div`
  padding: 2rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flexdirection: row;
  padding: 1.7rem 1.2rem;
  justify-content: center;
  h6 {
    margin-top: 1.6rem;
    margin-left: 18rem;
    font-size: 1.8rem;
  }
`;

export const ClearFileUploadCrossWrapper = styled.div`
  padding-top: 10px;
  display: flex;
`;

export const TextWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 0.1rem 1rem 1.2rem;
  overflow: hidden;
  h6 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  p {
    color: ${grey.z500};
    font-size: 1.2rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
